
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
    import JobViewApplyCtaIncomplete from '@/components/JobView/JobViewApplyCtaIncomplete';
    import JobViewApplyCtaComplete from '@/components/JobView/JobViewApplyCtaComplete';
    import JobViewApplyCtaNew from '@/components/JobView/JobViewApplyCtaNew';
    import JobViewMixin from '@/components/JobView/Mixins/JobViewMixin';
    import ApplyMixin from '@/components/JobView/Apply/ApplyMixin';
    import datalayer from '@/utils/datalayer';

    export default {
        name: 'JobViewApplyCta',

        components: {
            JobViewApplyCtaNew,
            JobViewApplyCtaComplete,
            JobViewApplyCtaIncomplete,
        },

        mixins: [JobViewMixin, ApplyMixin],

        props: {
            buttonSize: {
                type: String,
                default: 'lg',
            },
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
                $_jobApplication: state => state.jobApplication,
                $_isApplyEnabled: state => state.job.is_apply_enabled,
                $_tracking: state => state.eventTracking,
                $_me: state => state.me.user,
                $_profileTasks: state => state.me.profileTasks,
            }),

            ...mapGetters('job', {
                $_isApplyDisabled: 'isApplyDisabled',
            }),

            ...mapGetters('me', {
                $_hasRecentResume: 'hasRecentResume',
            }),

            offsiteApplyUrl() {
                return `${this.$siteUrl}job-redirect/${this.$_job.uuid}?flow=${this.$_job.flow_enabled === 'FLOW'}&token=${this.$_job.token}&source='button&page_referral_element=${this.$_tracking.page_referral_element}`;
            },
        },

        methods: {
            ...mapMutations('jobApplication', {
                $_OPEN_APPLY_FORM: 'OPEN_APPLY_FORM',
                $_OPEN_APPLY_OFFSITE_FORM: 'OPEN_APPLY_OFFSITE_FORM',
            }),

            ...mapMutations('job', {
                $_UPDATE_JOB: 'UPDATE_JOB',
            }),

            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
                $_pushSeekerJobEvent: 'pushSeekerJobEvent',
            }),

            apply() {
                this.eventApply();
                if (!this.$_isApplyEnabled) {
                    return false;
                }

                if (this.$_jobApplication.is_apply_form_open || this.$_jobApplication.is_apply_form_offsite_open) {
                    this.scroll();
                    return false;
                }

                if (this.$_job.is_onsite_apply) {
                    this.$_OPEN_APPLY_FORM();
                } else if (!this.$_me.id || (this.$_me.id && !this.$_hasRecentResume)) {
                    this.$_OPEN_APPLY_OFFSITE_FORM();
                } else {
                    this.eventJobOffsiteApplyRedirect();
                    window.open(this.offsiteApplyUrl, this.$isApp ? '_self' : '_blank');
                }
            },

            eventApply() {
                const data = {
                    event: 'job_apply_click',
                    site_position: 'job_apply',
                    ...this.$_jobData,
                };
                datalayer(data);

                this.$_pushEvent(data);
            },

            eventJobOffsiteApplyRedirect() {
                const data = {
                    event: 'job_offsite_apply_redirect',
                    site_position: 'job_apply',
                    ...this.$_jobData,
                };
                datalayer(data);
                this.$_pushEvent(data);
            },
        },
    };
